import _ from 'lodash'
import { useEffect, useState } from 'react'

const FAV_ACCOUNT_IDS_STORE_KEY = 'fav_account_ids'

interface UseFavoriteAccountIdsReturnValue {
  favAccountIdsSet: Set<string>,
  toggleFavorite: (accountId: string) => void,
}

const loadSet = (key: string): Set<string> => {
  const str = window.localStorage.getItem(key)
  let arr = []
  if (str) {
    try {
      arr = JSON.parse(str)
    } catch (err) {
      // console.error(`Failed to parse ${FAV_ACCOUNT_IDS_STORE_KEY} from local storage`)
    }
  }
  return new Set(arr)
}

const persistSet = (key: string, set: Set<string>) => {
  window.localStorage.setItem(key, JSON.stringify(Array.from(set)))
}

const useFavoriteAccountIds = (): UseFavoriteAccountIdsReturnValue => {
  const [favAccountIdsSet, setFavAccountIdsSet] = useState(loadSet(FAV_ACCOUNT_IDS_STORE_KEY))

  const toggleFavorite = (accountId: string): void => {
    const newSet = new Set(favAccountIdsSet)
    if (newSet.has(accountId)) {
      newSet.delete(accountId)
    } else {
      newSet.add(accountId)
    }
    persistSet(FAV_ACCOUNT_IDS_STORE_KEY, newSet)
    setFavAccountIdsSet(newSet)
  }

  return { favAccountIdsSet, toggleFavorite }
}

export default useFavoriteAccountIds
